// extracted by mini-css-extract-plugin
export var quillEditor = "_qq-1";
export var variable = "_qq-0";